/**
 * Simple AbortController utilities for request cancellation
 */

/**
 * Registry to track active controllers
 */
const activeControllers = new Map();

/**
 * Get an abort signal for a request key
 * Automatically cancels any previous request with the same key
 *
 * @param {string} key - Unique identifier for the request
 * @returns {AbortSignal} - Signal to use for the request
 */
export function getAbortSignal(key) {
    // Cancel previous request for this key
    if (activeControllers.has(key)) {
        const existingController = activeControllers.get(key);
        existingController.abort();
        activeControllers.delete(key);
    }

    // Create new controller
    const controller = new AbortController();
    activeControllers.set(key, controller);

    return controller.signal;
}
